module.exports = __webpack_public_path__ + "b4d07439e2358be9d2f88ff4ce9c4236.jpg";